// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const AuthProvider = registerClientReference(
    function() { throw new Error("Attempted to call AuthProvider() from the server but AuthProvider is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/Desktop/ZENODE/Internal/Credical/frontend/src/context/AuthContext.tsx",
    "AuthProvider",
);
export const useAuth = registerClientReference(
    function() { throw new Error("Attempted to call useAuth() from the server but useAuth is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/Desktop/ZENODE/Internal/Credical/frontend/src/context/AuthContext.tsx",
    "useAuth",
);
